<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="$route.meta.ifIncludes">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>
<style>
</style>
